import {ApolloLink, Observable} from 'apollo-link'
import Echo from 'laravel-echo/dist/echo'
window.Pusher = require('pusher-js')
class PusherLink extends ApolloLink {
    constructor () {
        super()
        const token = localStorage.getItem('access_token')
        this.subscriptions = []

        // uncomment if you're using the pusher service rather than the laravel websockets.
        // const config = {key: 'pusher-service-key', cluster: 'pusher-cluster',}

        // comment if you're using pusher service, not the laravel websockets.
        //const config = {wsHost: process.env.REACT_APP_SOCKET_HOST, wsPort: process.env.REACT_APP_SOCKET_PORT, wssPort: process.env.REACT_APP_SOCKET_PORT, key: process.env.REACT_APP_SOCKET_KEY}
        const config = process.env.REACT_APP_ENV === 'production' ?  {wsHost: process.env.REACT_APP_SOCKET_HOST, key: process.env.REACT_APP_SOCKET_KEY} : {wsHost: process.env.REACT_APP_SOCKET_HOST, wsPort: process.env.REACT_APP_SOCKET_PORT, wssPort: process.env.REACT_APP_SOCKET_PORT, key: process.env.REACT_APP_SOCKET_KEY}
        this.echo = new Echo({
            ...config,
            ...{
                broadcaster: 'pusher',
                authEndpoint: `${process.env.REACT_APP_API_URL}/graphql/subscriptions/auth`,
                disableStats: true,
                forceTLS: true, // false
                enabledTransports: ['ws', 'wss'],
                auth: {
                    headers: {
                        authorization: token ? `Bearer ${token}` : null
                    }
                }
            }
        })
    }

    request (operation, forward) {
        return new Observable(observer => {
            // Check the result of the operation
            forward(operation).subscribe({
                next: data => {
                    // If the operation has the subscription extension, it's a subscription
                    const subscriptionChannel = this._getChannel(data)
                    if (subscriptionChannel) {
                        this._createSubscription(subscriptionChannel, observer)
                    } else {
                        // No subscription found in the response, pipe data through
                        observer.next(data)
                        observer.complete()
                    }
                }
            })
        })
    }

    _getChannel (data) {
        return !!data.extensions && !!data.extensions.lighthouse_subscriptions && !!data.extensions.lighthouse_subscriptions.channel ? data.extensions.lighthouse_subscriptions.channel : null
    }

    _createSubscription (subscriptionChannel, observer) {
        const privateChannelName = subscriptionChannel.split('private-').pop()

        if (!this.subscriptions.find(s => s.channel === subscriptionChannel)) {
            this.subscriptions.push({
                channel: subscriptionChannel, observer
            })
        }
        this.echo.private(privateChannelName).listen('.lighthouse-subscription', payload => {
            if (!payload.more || observer._subscription._state === 'closed') {
                this._leaveSubscription(subscriptionChannel, observer)
                return
            }
            const result = payload.result
            if (result) {
                observer.next({
                    data: result.data, extensions: result.extensions
                })
            }
        })
    }

    _leaveSubscription (channel, observer) {
        const subscription = this.subscriptions.find(s => s.channel === channel)
        this.echo.leave(channel)
        observer.complete()
        this.subscriptions = this.subscriptions.slice(this.subscriptions.indexOf(subscription), 1)
    }
}

export default PusherLink